import { Injectable } from '@angular/core';
import { VehicleBuilder } from '../builders/vehicle-builder';
import { AuthenticatedApiService } from './authenticated-api.service';
import { ApiService } from './api.service';
import { AuthenticationService } from '../services/authentication.service';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
import * as i2 from "./api.service";
import * as i3 from "../services/authentication.service";
export class VehiclesApiService {
    constructor(api, unauthenticatedApi, auth) {
        this.api = api;
        this.unauthenticatedApi = unauthenticatedApi;
        this.auth = auth;
    }
    listVehicles() {
        return this.api.get('/vehicle/list').toPromise().then(response => {
            return response.vehicles.map(data => VehicleBuilder.buildVehicle(data));
        });
    }
    getVehicle(id, id_client) {
        let url = `/vehicle/${id}`;
        if (id_client) {
            url += `?id_client=${id_client}`;
        }
        return this.api.get(url).toPromise().then(response => {
            return VehicleBuilder.buildVehicle(response.vehicle);
        });
    }
    createVehicle(vehicle, identify = false) {
        let payload = VehicleBuilder.buildVehiclePayload(vehicle);
        if (vehicle.client_id) {
            payload.id_client = vehicle.client_id;
        }
        let accessToken = this.auth.getAccessToken();
        if (accessToken) {
            return this.api.post(`/vehicle${identify ? '?identify=1' : ''}`, JSON.stringify(payload))
                .toPromise().then(response => VehicleBuilder.buildVehicle(response.vehicle));
        }
        else {
            return this.unauthenticatedApi.post(`/vehicle${identify ? '?identify=1' : ''}`, JSON.stringify(payload))
                .toPromise().then(response => VehicleBuilder.buildVehicle(response.vehicle));
        }
    }
    updateVehicle(vehicle) {
        let payload = VehicleBuilder.buildVehiclePayload(vehicle);
        return this.api.put(`/vehicle/${vehicle.id}`, JSON.stringify(payload))
            .toPromise().then(response => VehicleBuilder.buildVehicle(response.vehicle));
    }
    deleteVehicle(id) {
        return this.api.delete(`/vehicle/${id}`).toPromise().then(response => response);
    }
    identifyVehicle(id) {
        let accessToken = this.auth.getAccessToken();
        if (accessToken) {
            return this.api.post(`/vehicle/identify/${id}`).toPromise()
                .then(response => {
                return VehicleBuilder.buildVehicle(response.vehicle);
            });
        }
        else {
            return this.unauthenticatedApi.post(`/vehicle/identify/${id}`).toPromise()
                .then(response => {
                return VehicleBuilder.buildVehicle(response.vehicle);
            });
        }
    }
    setVehicleUmc(id, params) {
        let accessToken = this.auth.getAccessToken();
        const payload = Object.assign({}, params);
        if (accessToken) {
            return this.api.post(`/vehicle/umc/${id}`, payload).toPromise().then(response => {
                return response.vehicle ? VehicleBuilder.buildVehicle(response.vehicle) : response;
            });
        }
        else {
            return this.unauthenticatedApi.post(`/vehicle/umc/${id}`, payload).toPromise().then(response => {
                return response.vehicle ? VehicleBuilder.buildVehicle(response.vehicle) : response;
            });
        }
    }
    getMotorOptions(id, id_client) {
        let accessToken = this.auth.getAccessToken();
        let url = `/vehicle/motor_options/${id}`;
        if (id_client) {
            url += `?id_client=${id_client}`;
        }
        if (accessToken) {
            return this.api.get(url).toPromise().then(response => response);
        }
        else {
            return this.unauthenticatedApi.get(url).toPromise().then(response => response);
        }
    }
    setVehicleWorkshopType(id, workshop_type) {
        let accessToken = this.auth.getAccessToken();
        const payload = { 'workshop_type': workshop_type };
        if (accessToken) {
            return this.api.post(`/vehicle/set_workshop_type/${id}`, payload).toPromise().then(response => {
                return response.vehicle ? VehicleBuilder.buildVehicle(response.vehicle) : response;
            });
        }
        else {
            return this.unauthenticatedApi.post(`/vehicle/set_workshop_type/${id}`, payload).toPromise().then(response => {
                return response.vehicle ? VehicleBuilder.buildVehicle(response.vehicle) : response;
            });
        }
    }
    setVehicleMotor(id, payload) {
        let accessToken = this.auth.getAccessToken();
        if (accessToken) {
            return this.api.post(`/vehicle/motor/${id}`, payload).toPromise().then(response => {
                return response.vehicle ? VehicleBuilder.buildVehicle(response.vehicle) : response;
            });
        }
        else {
            return this.unauthenticatedApi.post(`/vehicle/motor/${id}`, payload).toPromise().then(response => {
                return response.vehicle ? VehicleBuilder.buildVehicle(response.vehicle) : response;
            });
        }
    }
    setVehicleKm(id, km) {
        let accessToken = this.auth.getAccessToken();
        const payload = { 'km': km };
        if (accessToken) {
            return this.api.post(`/vehicle/km/${id}`, payload).toPromise().then(response => {
                return response.vehicle ? VehicleBuilder.buildVehicle(response.vehicle) : response;
            });
        }
        else {
            return this.unauthenticatedApi.post(`/vehicle/km/${id}`, payload).toPromise().then(response => {
                return response.vehicle ? VehicleBuilder.buildVehicle(response.vehicle) : response;
            });
        }
    }
    getBodyOptions(id, id_client) {
        let accessToken = this.auth.getAccessToken();
        let url = `/vehicle/body_options/${id}`;
        if (id_client) {
            url += `?id_client=${id_client}`;
        }
        if (accessToken) {
            return this.api.get(url).toPromise().then(response => response);
        }
        else {
            return this.unauthenticatedApi.get(url).toPromise().then(response => response);
        }
    }
    getPropulsionOptions(id) {
        let accessToken = this.auth.getAccessToken();
        if (accessToken) {
            return this.api.get(`/vehicle/propulsion_options/${id}`).toPromise().then(response => response);
        }
        else {
            return this.unauthenticatedApi.get(`/vehicle/propulsion_options/${id}`).toPromise().then(response => response);
        }
    }
    setVehicleBody(id, payload) {
        let accessToken = this.auth.getAccessToken();
        if (accessToken) {
            return this.api.post(`/vehicle/body/${id}`, payload).toPromise().then(response => {
                return response.vehicle ? VehicleBuilder.buildVehicle(response.vehicle) : response;
            });
        }
        else {
            return this.unauthenticatedApi.post(`/vehicle/body/${id}`, payload).toPromise().then(response => {
                return response.vehicle ? VehicleBuilder.buildVehicle(response.vehicle) : response;
            });
        }
    }
    setVehiclePropulsion(id, payload) {
        let accessToken = this.auth.getAccessToken();
        if (accessToken) {
            return this.api.post(`/vehicle/propulsion/${id}`, payload).toPromise().then(response => {
                return response.vehicle ? VehicleBuilder.buildVehicle(response.vehicle) : response;
            });
        }
        else {
            return this.unauthenticatedApi.post(`/vehicle/propulsion/${id}`, payload).toPromise().then(response => {
                return response.vehicle ? VehicleBuilder.buildVehicle(response.vehicle) : response;
            });
        }
    }
    getCarMakes() {
        let accessToken = this.auth.getAccessToken();
        if (accessToken) {
            return this.api.get(`/vehicle/car_makes`).toPromise().then(response => response);
        }
        else {
            return this.unauthenticatedApi.get(`/vehicle/car_makes`).toPromise().then(response => response);
        }
    }
    getCarModels(id_gt_carmake) {
        let accessToken = this.auth.getAccessToken();
        if (accessToken) {
            return this.api.get(`/vehicle/car_models/${id_gt_carmake}`).toPromise().then(response => response);
        }
        else {
            return this.unauthenticatedApi.get(`/vehicle/car_models/${id_gt_carmake}`).toPromise().then(response => response);
        }
    }
    getCarPropulsions(id_gt_car_model) {
        let accessToken = this.auth.getAccessToken();
        if (accessToken) {
            return this.api.get(`/vehicle/car_propulsion_codes/${id_gt_car_model}`).toPromise().then(response => response);
        }
        else {
            return this.unauthenticatedApi.get(`/vehicle/car_propulsion_codes/${id_gt_car_model}`).toPromise().then(response => response);
        }
    }
    getCarPropulsionsbyModelDescription(car_model_description) {
        let accessToken = this.auth.getAccessToken();
        if (accessToken) {
            return this.api.get(`/vehicle/car_propulsion_codes?model_description=${car_model_description}`).toPromise().then(response => response);
        }
        else {
            return this.unauthenticatedApi.get(`/vehicle/car_propulsion_codes?model_description=${car_model_description}`).toPromise().then(response => response);
        }
    }
}
VehiclesApiService.ɵfac = function VehiclesApiService_Factory(t) { return new (t || VehiclesApiService)(i0.ɵɵinject(i1.AuthenticatedApiService), i0.ɵɵinject(i2.ApiService), i0.ɵɵinject(i3.AuthenticationService)); };
VehiclesApiService.ɵprov = i0.ɵɵdefineInjectable({ token: VehiclesApiService, factory: VehiclesApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(VehiclesApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }, { type: i2.ApiService }, { type: i3.AuthenticationService }]; }, null); })();
//# sourceMappingURL=vehicles-api.service.js.map